import React, { useEffect, useState } from "react";
import { UiWhiteCard } from "../../_uiComponents/common/UiWhiteCard";
import { BillIcon } from "../../../styles/img/svg/BillIcon";
import { TransferIcon } from "../../../styles/img/svg/TransferIcon";
import { SettleCardIcon } from "../../../styles/img/svg/SettleCardIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  cardSettlementTypesRequest,
  creditCardClearFlowData,
  creditCardClearFormData,
  setCreditCardBillPaymentFLow,
} from "../../../_redux/_actions";
import { clearFundTransferForms } from "../../../_redux/_actions/fundTransfer.actions";
import { commonConstants, TRANSLATION_CONST } from "../../../_redux/_constants";
import { useTranslation } from "react-i18next";
import { SelectPayeeTypesPopup } from "./Popups/SelectPayeeTypesPopup";
import { BillPaymentIcon } from "../../../styles/img/svg/BillPaymentIcon";

export const OptionBoxes = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openCardTypeModal, setOpenCardTypeModal] = useState(false);
  const [listOfEligiblePayeeType, setListOfEligiblePayeeType] = useState([]);

  const { payeeTypeList, isPayeeTypeListLoading } = useSelector(
    (state) => state.creditCardPayments,
  );

  const goToDfccCreditCardBillForm = (params) => {
    dispatch(creditCardClearFormData());
    dispatch(setCreditCardBillPaymentFLow(params));
    navigate("/app/credit-cards-bill-settle");
  };

  const openSelection = () => {
    let payload = {
      isCreditCardPayee: true,
    };

    dispatch(cardSettlementTypesRequest(payload));
    setOpenCardTypeModal(true);
  };

  useEffect(() => {
    if (Array.isArray(payeeTypeList) && payeeTypeList.length > 0) {
      // Filter eligible payeeTypeList based on the status
      const eligiblePayeeTypeList = payeeTypeList.filter((payeeType) =>
        commonConstants.BILL_PAYMENT_SELECTOR_CREDIT_CARD_TYPE.includes(
          payeeType?.payeeTypeGroup?.name,
        ),
      );

      setListOfEligiblePayeeType(eligiblePayeeTypeList);
    }
  }, [payeeTypeList]);

  const goToBillPay = () => {
    navigate("/app/bill-payments");
  };

  const goToFundTransfer = () => {
    dispatch(clearFundTransferForms());
    navigate("/app/fund-transfer");
  };

  return (
    <>
      <div className="df-icon-card-wrapper">
        <UiWhiteCard
          onClick={() => goToFundTransfer()}
          className="df-icon-card"
        >
          <TransferIcon />
          <h5
            className={
              i18n.language === TRANSLATION_CONST?.TAMIL.lan &&
              "df-ic-title-tamil"
            }
          >
            {t("Fund Transfer")}
          </h5>
        </UiWhiteCard>

        <UiWhiteCard onClick={() => goToBillPay()} className="df-icon-card">
          <BillPaymentIcon />
          <h5
            className={
              i18n.language === TRANSLATION_CONST?.TAMIL.lan &&
              "df-ic-title-tamil"
            }
          >
            {t("Bill Payment")}
          </h5>
        </UiWhiteCard>

        {/* will be available in the future */}
        {/* <UiWhiteCard className="df-icon-card" onClick={() => openSelection()}>
          <SettleCardIcon />
          <h5
            className={
              i18n.language === TRANSLATION_CONST?.TAMIL.lan &&
              "df-ic-title-tamil"
            }
          >
            {t("Settle a Card")}
          </h5>
        </UiWhiteCard> */}
      </div>

      <SelectPayeeTypesPopup
        openModal={openCardTypeModal}
        isNoPaddingImage={true}
        closeModal={() => setOpenCardTypeModal(false)}
        payeeTypeList={listOfEligiblePayeeType}
        isPayeeTypeListLoading={isPayeeTypeListLoading}
        goToDfccCreditCardBillForm={goToDfccCreditCardBillForm}
      />
    </>
  );
};
